import { render, staticRenderFns } from "./Pendency.vue?vue&type=template&id=5520dc58"
import script from "./Pendency.vue?vue&type=script&lang=js"
export * from "./Pendency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports